<template>
  <div class="reader_innerSearch">
    <el-tabs v-model="activeName" class="reader_innerSearch_tabs">
      <el-tab-pane label="本页" name="page" class="h-full">
        <div class="contrainer">
          <div class="search">
            <el-input placeholder="关键词动态搜索" v-model="keyword" size="small" @keyup.enter.native="currentPageSearch"
              clearable @clear="currentPageSearch">
              <el-button slot="append" icon="el-icon-search" @click="currentPageSearch"></el-button>
            </el-input>
          </div>
          <div class="result_wrap" v-show="isShowResult && currentStatus !==0">
            <div class="current">{{ currentStatus === 1 ? '搜索内容已在右侧高亮展示' :'没搜到？换个关键词试试' }}</div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="本书" name="book" class="h-full" ref="bookref">
        <div class="contrainer h-full flex-col">
          <div class="search">
            <el-input placeholder="关键词动态搜索" size="small"  v-model="bookKeyword" @keyup.enter.native="getData" clearable
              @clear="getData">
              <el-button slot="append" icon="el-icon-search" @click="getData"></el-button>
            </el-input>
          </div>
          <div class="result_wrap" v-show="isShowBookResult && currentStatus !== 0">
            <template v-if="pageList.length">
              <div class="result" v-for="(page,pindex) in pageList" :key="pindex" :id="`search${page.juanNum}`">
                <div class="title" :class="page.juanNum - 1 == currentIndex?'active':''">{{ page.juanName }}</div>
                <div class="content">
                  <p v-for="(bookPage,index) in page.bookPageList" :key="index" @click="changePage(bookPage.juanNum-1)"
                    v-html="bookPage.text"></p>
                </div>
              </div>
            </template>
            <div class="current" v-if="!pageList.length && !loading"> 没搜到？换个关键词试试</div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>

  </div>
</template>

<script>
import { essearch } from '@/api/api'
export default {
  props: {
    currentIndex: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      activeName: 'page',
      keyword: '',
      isShowResult: false,
      currentStatus: 0,
      pageList: [],
      loading: false,
      activeIndex: this.currentIndex,
      bookKeyword: '',
      isShowBookResult: false,
      bookref: null
    }
  },
  watch: {
    'activeName': {
      handler (val, val1) {
        // 先清空数据
        this.$emit('getSearch', '')
        this.isShowResult = false
        this.isShowBookResult = false
        if (val === 'page' && this.keyword.trim() !== '') {
          this.isShowResult = true
          this.$emit('getSearch', this.keyword)
        }
        if (val === 'book' && this.bookKeyword.trim() !== '') {
          this.isShowBookResult = true
          this.$emit('getSearch', this.bookKeyword)
        }
      }
    },
    currentIndex: {
      handler (val) {
        this.activeIndex = val
      }
    }
  },
  mounted () {
    // if (this.$route.query && this.$route.query.search) {
    //   const search = JSON.parse(this.$route.query.search)
    //   if (search.keyword) {
    //     setTimeout(() => {
    //       this.bookKeyword = search.keyword
    //       this.activeName = 'book'
    //       this.getData()
    //     }, 0)
    //     let timer = null
    //     timer = setInterval(() => {
    //       const pageDom = document.getElementById(`search${this.activeIndex + 1}`)
    //       if (pageDom) {
    //         pageDom && pageDom.scrollIntoView && pageDom.scrollIntoView({ behavior: 'smooth' })
    //         clearInterval(timer)
    //       }
    //     }, 200)
    //   }
    // }
  },
  methods: {
    // clearValue () {
    //   this.keyword = ''
    //   this.isShowResult = false
    //   this.$emit('getSearch', this.keyword)
    // },
    setCurrentStatus (val) {
      this.currentStatus = val
    },
    currentPageSearch () {
      if (this.keyword.trim() === '') {
        this.isShowResult = false
      } else {
        this.isShowResult = true
      }
      this.$emit('getSearch', this.keyword)
    },
    getData () {
      if (this.bookKeyword.trim() === '') {
        this.isShowBookResult = false
        this.pageList = []
        this.$emit('getSearch', this.bookKeyword)
        return false
      }
      let bookIds = ''
      if (this.$route.query && this.$route.query.bookId) {
        bookIds = this.$route.query.bookId
      }
      this.isShowBookResult = true
      this.loading = true
      const _this = this
      try {
        essearch({ keyword: this.bookKeyword, bookIds }).then(res => {
          if (res.data.bookList.length) {
            _this.pageList = res.data.bookList[0]['bookJuanList']
          } else {
            _this.pageList = []
          }
          _this.loading = false
          this.$emit('getSearch', this.bookKeyword)
        })
      } catch (error) {
        _this.loading = false
      }
    },
    changePage (val) {
      this.$emit('changePage', val)
    }
  }
}
</script>
<style lang="less" scoped>
.reader_innerSearch {
  height: 100%;
  overflow: hidden;
  .reader_innerSearch_tabs{
    display: flex;
    height: 100%;
    flex-direction: column;
    overflow: hidden;
    /deep/ .el-tabs__content {
      flex: 1;
      overflow: hidden;
    }
  }
  .current{
    padding: 0 20px 20px 20px;
  }

  .contrainer{
    height: 100%;
    overflow: auto;
    .search{
      padding:18px 20px 14px 20px;
      /deep/ .el-input-group__append{
        background: none;
        border-left: 0;
        padding: 0 10px;
      }
    }
    .result_wrap{
      flex:1;
      overflow: auto;
      .result{
        margin-bottom: 12px;
      }
      .title{
        width: 100%;
        height: 28px;
        line-height: 28px;
        background: transparent;
        color: rgba(51, 51, 51, 1);
        padding:0 20px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        font-weight: 700;
        font-size: 14px;
        &.active{
          background: rgba(44, 126, 141, 0.08);
        }
      }
      .content{
        padding: 0 20px 0 44px;
        p{
          width: 100%;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          color:rgba(51, 51, 51, 0.8);
          font-size: 14px;
          line-height: 14px;
          margin-top: 12px;
          margin-bottom: 0;
        }
      }
    }
  }
  /deep/ .el-tabs__nav,
  /deep/ .el-tabs__header {
    width:100%;
    background: rgba(255, 255, 255, 0.8) !important;
    border-bottom: 1px solid rgba(238, 238, 238, 1)!important;
    margin: 0;
  }
  /deep/ .el-tabs__active-bar{
    background-color: #2C7E8D ;
  }
  /deep/ .el-tabs__item {
    width: 50%!important;
    border: 0 !important;
    color: rgba(102, 102, 102, 1)!important;
    margin: 0!important;
    background-color: rgba(255, 255, 255, 0.8)!important;
    &.is-active {
      color: #2C7E8D  !important;
      background-color: rgba(255, 255, 255, 0.8);
    }
  }
  /deep/ .el-tabs__nav-wrap::after{
    background-color: #EEEEEE;
    height: 1px;
  }
  /deep/ .el-tabs__active-bar{
    width:24px!important;
    left: 49px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/read/components/innerSearch.vue